export default "__VITE_ASSET__CatY3uFg__"